// TODO: Find a way to get ticket with the specific status in the JIRA
export enum TicketStatus {
  AWAITING_TENANT_ACCEPTANCE = 'Avventer bekreftelse fra leietaker',
  CLOSED = 'Closed',
  TERMINATION_CANCELLED = 'Oppsigelse kansellert',
  OPEN = 'Open',
}
